import api from './api';
import { LOADS_API_URL } from '../../env';

const apiUrl = LOADS_API_URL;

const updateLoadStatusUrl = `${apiUrl}/Load/PostLoadStatus`;
const updateLoadVisibilityAppStatusUrl = `${apiUrl}/Load/PostUpdateVisibilityAppStatusEventRequest`;
const resolveLoadProblemUrl = `${apiUrl}/Load/PostResolveLoadProblem`;
const updateManualTrackingUrl = `${apiUrl}/Load/PostManualTrackLoadLocation`;
const setLoadProblemUrl = `${apiUrl}/Load/PostSetLoadProblem`;
const bounceLoadUrl = `${apiUrl}/Load/PostLoadBounceProblem`;
const loadSummaryUrl = `${apiUrl}/Load/GetLoadSummary`;
const loadDetailUrl = `${apiUrl}/Load/GetLoadDetails`;
const secondaryLoadInfoUrl = `${apiUrl}/Load/GetSecondaryLoadInfo`;
const checkEmailServiceHealthUrl = `${apiUrl}/Load/EmailServiceHealth`;
const lockLoadUrl = `${apiUrl}/Load/Lock`;
const unlockLoadUrl = `${apiUrl}/Load/Unlock`;
const refreshLockUrl = `${apiUrl}/Load/RefreshLock`;
const updateDriverInformationUrl = `${apiUrl}/Load/UpdateDriverInfo`;
const updateEquipmentInformationUrl = `${apiUrl}/Load/PostTruckTrailerNumbers`;
const commentOnActivityUrl = `${apiUrl}/Load/PostCommentActivity`;
const updateDispatcherInformationUrl = `${apiUrl}/Load/UpdateDispatcherInfo`;
const updateShipmentStopUrl = `${apiUrl}/Load/UpdateShipmentInfo`;
const updateIdentifierInformationUrl = `${apiUrl}/Load/PostUpdateReferenceIds`; // TODO: Update when endpoint becomes available. TT-2021
const updateInterlineCarrierInformationUrl = `${apiUrl}/Load/UpdateInterlineCarrierInformation`; // TODO: Update when endpoint becomes available. TT-2021

export async function updateLoadStatus(payload, salesOrderBk) {
  const options = {
    url: updateLoadStatusUrl,
    data: {
      ...payload,
    },
    params: {
      salesOrderBk,
    },
  };
  return api.post(options);
}

export async function updateLoadVisibilityAppStatus(payload) {
  const options = {
    url: updateLoadVisibilityAppStatusUrl,
    data: {
      ...payload,
    },
  };
  return api.post(options);
}

export async function resolveLoadProblem(payload) {
  const options = {
    url: resolveLoadProblemUrl,
    data: {
      ...payload,
    },
  };
  return api.post(options);
}

export async function updateManualTracking(payload) {
  const options = {
    url: updateManualTrackingUrl,
    data: {
      ...payload,
    },
  };
  return api.post(options);
}

export async function setLoadProblem(payload) {
  const options = {
    url: setLoadProblemUrl,
    data: {
      ...payload,
    },
  };
  return api.post(options);
}

export async function bounceLoad(payload) {
  const options = {
    url: bounceLoadUrl,
    data: {
      ...payload,
    },
  };
  return api.post(options);
}

export async function getLoadSummary(loadId, salesOrderBk, modeType) {
  const options = {
    url: loadSummaryUrl,
    params: {
      loadId,
      salesOrderBk,
      modeType,
    },
  };

  return api.get(options);
}

export async function getLoadDetails(loadId, salesOrderBk, modeType) {
  const options = {
    url: loadDetailUrl,
    params: {
      loadId,
      salesOrderBk,
      modeType,
    },
  };

  return api.get(options);
}

export async function getCarrierInfo(carrierId) {
  const options = {
    url: secondaryLoadInfoUrl,
    params: {
      carrierId,
    },
  };

  return api.get(options);
}

export async function checkEmailServiceHealth() {
  const options = {
    url: checkEmailServiceHealthUrl,
  };

  return api.get(options);
}

export async function lockLoad(loadId) {
  const options = {
    url: lockLoadUrl,
    params: {
      loadId,
    },
  };

  return api.post(options);
}

export async function unlockLoad(loadId) {
  const options = {
    url: unlockLoadUrl,
    params: {
      loadId,
    },
  };

  return api.post(options);
}

export async function refreshLock(loadId) {
  const options = {
    url: refreshLockUrl,
    params: {
      loadId,
    },
  };

  return api.post(options);
}

export async function updateDriverInformation(payload) {
  const options = {
    url: updateDriverInformationUrl,
    data: {
      ...payload,
    },
  };

  return api.post(options);
}

export async function updateEquipmentInformation(payload) {
  const options = {
    url: updateEquipmentInformationUrl,
    data: {
      ...payload,
    },
  };

  return api.post(options);
}

export async function updateDispatcherInformation(payload) {
  const options = {
    url: updateDispatcherInformationUrl,
    data: {
      ...payload,
    },
  };

  return api.post(options);
}

export async function commentOnActivity(payload) {
  const options = {
    url: commentOnActivityUrl,
    data: payload,
  };

  return api.post(options);
}

export async function updateShipmentStop(payload, salesOrderBk) {
  const options = {
    url: updateShipmentStopUrl,
    data: payload,
    params: {
      salesOrderBk,
    },
  };

  return api.post(options);
}

// TODO: Update when endpoint becomes available. TT-2021
export async function updateIdentifierInformation(payload, salesOrderBk) {
  const options = {
    url: updateIdentifierInformationUrl,
    data: payload,
    params: {
      salesOrderBk,
    },
  };

  return api.post(options);
}

// TODO: Update when endpoint becomes available. TT-2021
export async function updateInterlineCarrierInformation(payload, salesOrderBk) {
  const options = {
    url: updateInterlineCarrierInformationUrl,
    data: payload,
    params: {
      salesOrderBk,
    },
  };

  return api.post(options);
}
